import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class PaymentRecordsFinancialTransactions extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
      downloads_div:'',
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','part_time_employee_payment_records_financial_transactions');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
      }else{
        url = "/php/admin_part_time_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
            cutThis.downloads_files(data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  downloads_files(data){
    var emp_id  = data['emp_id'];
    var file_id = data['id'];
    var downloads_div = [];
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'total_payments_made')}><i class="fas fa-file-download"></i> Total Payments Made</a></div>);
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'payment_frequency')}><i class="fas fa-file-download"></i> Mode of Payment</a></div>);
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'mode_of_payment')}><i class="fas fa-file-download"></i> TDS Deduction Details</a></div>);
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'gst_invoicing_tax_compliance')}><i class="fas fa-file-download"></i> GST Invoicing &amp; Tax Compliance</a></div>);
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'tds_deduction_details')}><i class="fas fa-file-download"></i> Payment Frequency &amp; Ledger Entry</a></div>);
    this.setState({downloads_div});
  }

  check_download_file(file_id,emp_id,file_name){
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var form_type         = 'part_time_employee_payment_records_financial_transactions';
    var url = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
    }else{
      url = "/php/admin_part_time_employee_management_url.php";
    }
    var new_str = '?emp_id='+emp_id+"&file_id="+file_id+'&file_name='+file_name+"&function=check_download_emp_file&form_type="+form_type+"&web_token="+web_token;
    window.open(url+new_str, '_blank');
  }

  update_info(data){

    $('#old_total_payments_made').val(data['total_payments_made_new_name']);
    $('#old_mode_of_payment').val(data['mode_of_payment_new_name']);
    $('#old_tds_deduction_details').val(data['tds_deduction_details_new_name']);
    $('#old_gst_invoicing_tax_compliance').val(data['gst_invoicing_tax_compliance_new_name']);
    $('#old_payment_frequency').val(data['payment_frequency_new_name']);
  }

  add_emp_basic_details(){
    var file_main_ext       = ['png','jpg','jpeg','JPEG','JPG','PNG','pdf','PDF'];
    var cutThis             = this;
    var emp_id              = cutThis.props.id;
    var web_token           = window.isNullAndUndef($('#web_token').val());


    var total_payments_made_temp    = window.isNullAndUndef($('#total_payments_made').val());
    var org_total_payments_made     = $("#total_payments_made").prop("files")[0];
    var total_payments_made_name    = $('#total_payments_made').val().split('\\').pop();

    var mode_of_payment_temp        = window.isNullAndUndef($('#mode_of_payment').val());
    var org_mode_of_payment         = $("#mode_of_payment").prop("files")[0];
    var mode_of_payment_name        = $('#mode_of_payment').val().split('\\').pop();

    var tds_deduction_details_temp        = window.isNullAndUndef($('#tds_deduction_details').val());
    var org_tds_deduction_details         = $("#tds_deduction_details").prop("files")[0];
    var tds_deduction_details_name        = $('#tds_deduction_details').val().split('\\').pop();

    var payment_frequency_temp        = window.isNullAndUndef($('#payment_frequency').val());
    var org_payment_frequency         = $("#payment_frequency").prop("files")[0];
    var payment_frequency_name        = $('#payment_frequency').val().split('\\').pop();

    var gst_invoicing_tax_compliance_temp        = window.isNullAndUndef($('#gst_invoicing_tax_compliance').val());
    var org_gst_invoicing_tax_compliance         = $("#gst_invoicing_tax_compliance").prop("files")[0];
    var gst_invoicing_tax_compliance_name        = $('#gst_invoicing_tax_compliance').val().split('\\').pop();


    var total_payments_made_ext    = '';
    var mode_of_payment_ext  = '';
    var tds_deduction_details_ext  = '';
    var payment_frequency_ext  = '';
    var gst_invoicing_tax_compliance_ext  = '';

    if(total_payments_made_temp && mode_of_payment_temp && tds_deduction_details_temp && payment_frequency_temp && gst_invoicing_tax_compliance_temp){
      total_payments_made_ext       = total_payments_made_temp.split('.').pop();
      mode_of_payment_ext        = mode_of_payment_temp.split('.').pop();
      tds_deduction_details_ext        = tds_deduction_details_temp.split('.').pop();
      payment_frequency_ext        = payment_frequency_temp.split('.').pop();
      gst_invoicing_tax_compliance_ext        = gst_invoicing_tax_compliance_temp.split('.').pop();
    }
    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(file_main_ext.indexOf(total_payments_made_ext) >= 0 && file_main_ext.indexOf(mode_of_payment_ext) >= 0 && file_main_ext.indexOf(tds_deduction_details_ext) >= 0 && file_main_ext.indexOf(payment_frequency_ext) >= 0 && file_main_ext.indexOf(gst_invoicing_tax_compliance_ext) >= 0){
      var old_total_payments_made                 = $('#old_total_payments_made').val();
      var old_mode_of_payment                  = $('#old_mode_of_payment').val();
      var old_tds_deduction_details                  = $('#old_tds_deduction_details').val();
      var old_payment_frequency                  = $('#old_payment_frequency').val();
      var old_gst_invoicing_tax_compliance                  = $('#old_gst_invoicing_tax_compliance').val();
      var all_data                              = {};


      all_data['total_payments_made']             = window.return_false_null(total_payments_made_name);
      all_data['mode_of_payment']                 = window.return_false_null(mode_of_payment_name);
      all_data['tds_deduction_details']                 = window.return_false_null(tds_deduction_details_name);
      all_data['payment_frequency']                 = window.return_false_null(payment_frequency_name);
      all_data['gst_invoicing_tax_compliance']                 = window.return_false_null(gst_invoicing_tax_compliance_name);
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('total_payments_made',org_total_payments_made);
      body.append('old_total_payments_made',old_total_payments_made);
      body.append('mode_of_payment',org_mode_of_payment);
      body.append('old_mode_of_payment',old_mode_of_payment);
      body.append('tds_deduction_details',org_tds_deduction_details);
      body.append('old_tds_deduction_details',old_tds_deduction_details);
      body.append('payment_frequency',org_payment_frequency);
      body.append('old_payment_frequency',old_payment_frequency);
      body.append('gst_invoicing_tax_compliance',org_gst_invoicing_tax_compliance);
      body.append('old_gst_invoicing_tax_compliance',old_gst_invoicing_tax_compliance);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','part_time_employee_payment_records_financial_transactions');
      body.append('function','add_part_time_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
      }else{
        url = "/php/admin_part_time_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           async: false,
           data: body,
           enctype: 'multipart/form-data',
           processData: false,
           contentType: false,
           cache: false,
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
          cutThis.get_emp_basic_details();
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('total_payments_made','mode_of_payment','tds_deduction_details','payment_frequency','gst_invoicing_tax_compliance');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_total_payments_made" placeholder=""/>
                                        <input type="file" className="form-control" id="total_payments_made" placeholder="Total Payments Made"/>
                                        <label for="name">Total Payments Made</label>
                                    </div>
                                </div>


                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_mode_of_payment" placeholder=""/>
                                        <input type="file" className="form-control" id="mode_of_payment" placeholder="Mode of Payment"/>
                                        <label for="name">Mode of Payment</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_tds_deduction_details" placeholder=""/>
                                        <input type="file" className="form-control" id="tds_deduction_details" placeholder="TDS Deduction Details"/>
                                        <label for="name">TDS Deduction Details</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_gst_invoicing_tax_compliance" placeholder=""/>
                                        <input type="file" className="form-control" id="gst_invoicing_tax_compliance" placeholder="GST Invoicing &amp; Tax Compliance"/>
                                        <label for="name">GST Invoicing &amp; Tax Compliance</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_payment_frequency" placeholder=""/>
                                        <input type="file" className="form-control" id="payment_frequency" placeholder="Payment Frequency &amp; Ledger Entry"/>
                                        <label for="name">Payment Frequency &amp; Ledger Entry</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                    <div className="col-md-4">
                                      <p id="error_msg"></p>
                                    </div>
                                    <div className="col-md-4">
                                      <p># Form upload, only allow PDF, JPEG, JPG & PNG</p>
                                    </div>
                                    <div className="col-md-4 p-0 float_r">
                                        {this.state.submit_button}
                                    </div>
                                </div>
                                {this.state.downloads_div}


                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default PaymentRecordsFinancialTransactions;
